// Indiscriminately strips html tags from input string
const stripHtml = (html: string) => (html ? html?.replace(/<[^>]*>|\n/gim, '').trim() : '')
export default stripHtml
